import { render, staticRenderFns } from "./EmailContentEditor.vue?vue&type=template&id=1a39a7da&scoped=true&"
import script from "./EmailContentEditor.vue?vue&type=script&lang=ts&"
export * from "./EmailContentEditor.vue?vue&type=script&lang=ts&"
import style0 from "./EmailContentEditor.vue?vue&type=style&index=0&id=1a39a7da&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39a7da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
